export default "__VITE_ASSET__DQ3HSIwZ__"